import * as colors from '../styles/colors';
import getPropertyPatrols from './getPropertyPatrols';

export default (property, darsByPropertyId) => {
  let color = colors.markers.property.NO_SERVICE;
  let reason = 'Nothing needs to be done';
  let zIndex = 93;
  let patrols = null;
  if (property.instanceId) {
    color = colors.markers.property.HIGH_PRIORITY;
    reason = 'Requires immediate response';
    zIndex = 99;
  } else {
    patrols = getPropertyPatrols({ property, darsByPropertyId });
    if (patrols) {
      color = patrols.color;
      reason = patrols.reason;
      zIndex = patrols.zIndex;
    } else if (property.cardinal) {
      zIndex = 95;
    }
  }
  return {
    ...property,
    markerParams: { color, zIndex, patrols, reason }
  };
}